import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import styles from './service.scss';

const Service = ({ document }) => {
  const {
    fields: { images, description, title },
  } = document;

  const image = images[0].fields;

  return (
    <li className={styles.service}>
      <div className={styles.imgWrapper}>
        <img
          className={styles.stepImage}
          src={`${image.file.url}?fm=webp`}
          alt={image.description || ''}
          aria-hidden="true"
        />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.description}>
          {documentToReactComponents(description)}
        </div>
      </div>
    </li>
  );
};

export default Service;
